<template lang="pug">
footer.py-5
  .container-fluid
    .row
        .univ_collaborators.col-md-8
            .row(style='margin-bottom: 50px')
                .collaborators-icons
                    .images-container
                        .compomics-logo
                            a(target='_blank' href='https://compomics.com')
                                img(src='../assets/logos/compomics_logo_2019_neg.png' alt='compomics')
                        .ib2-logo
                            a(target='_blank' href='http://ibsquare.be/')
                                img(src='../assets/logos/IB2logo_3.png' alt='ibsquare')
                        .cmb-logo
                            a(target='_blank' href='http://mbc.vib-ugent.be/')
                                img(src='../assets/logos/vib_rf_medical_biotechnology_rgb_neg.png' alt='vib')
                        .ugent-logo
                            a(target='_blank' href='https://www.ugent.be/')
                                img(src='../assets/logos/logo_UGent_EN_RGB_2400_white_cropped.png' alt='ugent')
                        .vub-logo
                            a(target='_blank' href='https://www.vub.ac.be/en')
                                img(src='../assets/logos/vub-logo-rgb.png' alt='vub')
                        .elixir-logo
                            a(target='_blank' href='https://www.elixir-belgium.org/')
                                img(src='../assets/logos/elixir-belgium-logo_Aug2020.png' alt='elixir-belgium')
            .row.license
                .col-md-12
                    p
                    | Licensed under 
                    a(href='https://creativecommons.org/licenses/by/4.0/' target='_blank') CC BY 4.0
        .contact_and_docs.col-md-4
            //- .row
            //-     .col-md-12
            //-         h4 Documentation
            //-         p You can find documentation in PDF 
            //-             a(target='_blank' href='http://genesis.ugent.be/uvpublicdata/Scop3p/Scop3P_manual.pdf') here
            //-             | .
            //-         h5 For developers
            //-         p Scop3P 
            //-             a(href='swagger-ui/') API
            //- .row
            //-     .col-md-12
            //-         h4 Contact us
            //-         p For any further questions, feedback or suggestions, please send an email to: 
            //-             br
            //-             a.email_link(href='mailto:scop3p.compomics@vib-ugent.be') scop3p.compomics@vib-ugent.be

</template>
<script>
export default {
    name: 'CustomFooter'
}
</script>

<style lang="scss" scoped>
footer {
    bottom: 0;
    height: 325px;
    width: 100%;
    background-color:  #1b2944 !important;
    /* background-color: #1cbbba !important; */
    /* background-color: #f7f4f9; */
    color: white;
    /* color: rgba(0, 0, 0, 0.9); */

    .collaborators-icons ul{
        list-style: none;
    }
    .collaborators-icons ul li{
        display: inline;
        margin: 0 25px;
    }
    .images-container{
        display: flex;
        div {
            margin: 0 25px;
        }
        img {
            width: 100%;
            height: auto;
            vertical-align: middle;
        }
    }
    .cmb-logo { flex: 2.7396; }
    .ib2-logo { flex: 1; }
    .ugent-logo { flex: 1.1366; }
    .compomics-logo { flex: 2.4555; }
    .elixir-logo{ flex: 1.5159; }
    .vub-logo{ flex: 2.2450; }

    .license {
        bottom: 0;
        position: absolute;
    }
    a {
        color: #8ec2fa;
    }
    .email_link {
        text-decoration: underline;
    }
}
</style>
